module.exports = __webpack_public_path__ + "img/img_jinbi@2x.b9af18a0.png";